export enum ClientIdSection {
  applications = 'applications',
  users = 'users',
  tenants = 'tenants',
  services = 'services',
  apikeys = 'apikeys',
  licenses = 'licenses',
  requests = 'requests',
}
